<template>
  <b-modal v-if="query != null" ref="search-form-modal" :visible="show" body-bg-variant="soft-secondary"
           @hidden="closeForm" @close="closeForm"
           hide-footer hide-header size="lg">
    <div class="media align-items-center mb-2">
      <div class="media-body">
        <h2 class="text-primary pt-2">Search for Deals</h2>
      </div>
      <figure class="w-100 max-w-7rem mr-3" style="">
        <img class="img-fluid" src="/assets/svg/icons/icon-26.svg" alt="SVG">
      </figure>
    </div>
    <form class="mt-2">
      <label for="remortgageType" class="input-label">What type of mortgage deal are you looking for?</label>
      <!-- Button Group -->
      <div class="btn-group btn-group-toggle btn-group-segment d-flex form-group" data-toggle="buttons">
        <label :class="'btn btn-sm flex-fill' + (isRemortgage ? ' active' : '')">
          <input type="radio" id="remortgageType" @click="switchToRemortgage()"> Remortgage
        </label>
<!--        <label :class="'btn btn-sm flex-fill' + (isFirstTimeBuyer ? ' active' : '')">-->
<!--          <input type="radio" id="firstTimeBuyerType" @click="switchToFirstTimeBuyer()"> First-Time-Buyer-->
<!--        </label>-->
        <label class="btn btn-sm flex-fill disabled">
          <input type="radio" id="firstTimeBuyerType"> First-Time-Buyer <span class="badge badge-soft-primary">Coming soon</span>
        </label>
        <label class="btn btn-sm flex-fill disabled">
          <input type="radio" id="buyToLetType" @click="form.type = 'buy-to-let'"> Buy-to-Let <span class="badge badge-soft-primary">Coming soon</span>
        </label>
      </div>
      <!-- End Button Group -->
      <b-tabs :value="tabIndex" content-class="mt-3" nav-wrapper-class="w-25 d-none">
        <b-tab title="Welcome">Welcome</b-tab>
        <b-tab title="Remortgage">
          <div class="row">
            <div class="col-sm-4">
              <!-- Form Group -->
              <div class="form-group">
                <label for="propertyValue1" class="input-label">Property value</label>
                <money v-model="form.propertyValue" id="propertyValue1" class="form-control" ></money>
              </div>
              <!-- End Form Group -->
            </div>
            <div class="col-sm-4">
              <!-- Form Group -->
              <div class="form-group">
                <label for="remainingBalance1" class="input-label">Remaining Balance</label>
                <money v-model="form.remainingBalance" id="remainingBalance1" class="form-control" ></money>
              </div>
              <!-- End Form Group -->
            </div>
            <div class="col-sm-4">
              <!-- Form Group -->
              <div class="form-group">
                <label for="term1" class="input-label">Term</label>
                <the-mask v-model="form.term" id="term1" class="form-control" mask="##" type="number" mmasked="false" placeholder="00"></the-mask>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8">
              <div class="form-group">
                <label class="input-label">Your current lender</label>
                <multiselect v-model="form.currentLender" :options="allLenders" placeholder="Select lender..."
                             :searchable="true" label="lenderName" track-by="lenderName">
                </multiselect>
              </div>
            </div>
            <div class="col-sm-4">
              <!-- Form Group -->
              <div class="form-group">
                <label for="currentMonthly" class="input-label">Your monthly repayment</label>
                <money v-model="form.currentMonthly" @blur="$emit('updated', queryData)" :disabled="form.currentLender == null" id="currentMonthly" class="form-control" ></money>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="First-Time-Buyer">
          <div class="row">
            <div class="col-sm-4">
              <!-- Form Group -->
              <div class="form-group">
                <label for="propertyValue2" class="input-label">Property value</label>
                <money v-model="form.propertyValue" id="propertyValue2" class="form-control" ></money>
              </div>
              <!-- End Form Group -->
            </div>
            <div class="col-sm-4">
              <!-- Form Group -->
              <div class="form-group">
                <label for="deposit" class="input-label">Deposit</label>
                <money v-model="form.deposit" id="deposit" class="form-control" ></money>
              </div>
              <!-- End Form Group -->
            </div>
            <div class="col-sm-4">
              <!-- Form Group -->
              <div class="form-group">
                <label for="term2" class="input-label">Term</label>
                <the-mask v-model="form.term" id="term2" class="form-control" mask="##" type="number" mmasked="false" placeholder="00"></the-mask>
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="Buy-to-Let" disabled></b-tab>
      </b-tabs>
      <!-- End Row -->

      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-sm btn-soft-secondary mr-2" @click="closeForm">Close</button>
        <button type="button" class="btn btn-sm btn-success" @click="saveChanges">Save Changes</button>
      </div>
    </form>  
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from "vuex";
import { Money } from 'v-money'
import { QUERY_REMORTGAGE, QUERY_FIRST_TIME_BUYER, QUERY_HOME_MOVER }  from "@/utils/Constants";
import {ProductSearchQuery} from "@/utils/ProductSearchQuery";

export default {
  name: "ProductQuickSearchModal",
  
  components: {
    Multiselect,
    Money
  },
  
  data() {
    return {
      form: {}
    }
  },
  
  props: {
    show: Boolean,
    query: Object
  },

  watch: {
    show: {
      deep: true,
      handler: function (val, oldVal) {
        // Handler here to copy the new query values
        // into the form to avoid side-affects from
        // the 3rd-party components not handling NULL values
        //
        if (this.query == null || val === false) return;

        this.form = new ProductSearchQuery(this.query);
        this.form.type = this.query.type;
        this.form.remainingBalance = this.query.remainingBalance ?? 0;
        this.form.propertyValue = this.query.propertyValue ?? 0;
        this.form.term = this.query.term ?? 20;
        this.form.deposit = this.query.deposit ?? 0;
        this.form.currentLender = this.query.currentLender;
        this.form.currentMonthly = this.query.currentMonthly ?? 0;
      }
    }
  },
  
  computed: {
    ...mapGetters([
      "allLenders"
    ]),
    
    isRemortgage() {
      return this.form.type === QUERY_REMORTGAGE;  
    },
    
    isFirstTimeBuyer() {
      return this.form.type === QUERY_FIRST_TIME_BUYER;
    },
    
    tabIndex() {
      if (this.form.type === QUERY_REMORTGAGE) return 1;
      else if (this.form.type === QUERY_FIRST_TIME_BUYER) return 2;
      else return 0;
    },
    
    queryData() {
      if (this.form.type !== QUERY_REMORTGAGE && this.form.type !== QUERY_FIRST_TIME_BUYER)
        return null;

      let formData = {
        type: this.form.type,
        propertyValue: this.form.propertyValue,
        term: Number(this.form.term)
      };
      if (this.form.type === QUERY_REMORTGAGE) {
        formData.remainingBalance = this.form.remainingBalance;
        formData.currentLender = this.form.currentLender;
        formData.currentMonthly = this.form.currentLender != null && this.form.currentMonthly > 0 ? this.form.currentMonthly : null;
      }
      else if (this.form.type === QUERY_FIRST_TIME_BUYER) {
        formData.deposit = this.form.deposit
      }
      
      return formData;
    }
  },

  methods: {
    closeForm() {
      this.$refs['search-form-modal'].hide();
      this.$emit("closed");
    },
    
    saveChanges() {
      this.$refs['search-form-modal'].hide();
      this.$emit("saved", this.queryData);
    },
    
    switchToRemortgage() {
      this.form.type = QUERY_REMORTGAGE;
    },
    
    switchToFirstTimeBuyer() {
      this.form.type = QUERY_FIRST_TIME_BUYER;
    }
  }
}
</script>

<style scoped>
.option__image, .option__desc {
  display: inline-block;
  vertical-align: middle;
}
.option__desc {
  padding: 10px;
}

input.form-control {
  height: 40px !important;
}
</style>